<div [formGroup]="childForm">
  <div class="row" [formGroupName]="formGroupName">
    <input type="hidden" formControlName="id" />
    <input type="hidden" formControlName="name" />
    <div class="col-md-4 input-container">
      <mat-form-field appearance="outline" class="w-100 m-b-10">
        <mat-label>{{ 'value' | translate }} {{title}} </mat-label>
        <input matInput type="number" class="txt" placeholder="{{ 'value' | translate }} {{title}}" formControlName="value"
          maxlength="3" minlength="1" #value (focus)="GetFocusPlaceholder(value,'EGP')"/>

        @if(childForm.get([formGroupName,'value'])?.touched && childForm.get([formGroupName,'value'])?.invalid)
        {
        <mat-hint class="m-b-16 error-msg">
          <div class="text-error"> {{ 'EnterValue' | translate }}</div>
        </mat-hint>
        }
      </mat-form-field>
    </div>
  </div>
</div>